import { Swiper } from 'swiper/react'
import { StoryType } from '~/widgets/Stories'
import { Img } from '~/shared/ui/Img'
import { Skeleton } from '~/shared/ui/SkeletonList'

import {
  Wrapper,
  SwiperSlide,
  DescriptionWrapper,
  ImageWrapper,
  TitleWrapper,
  StoryContent,
  StoryContentBlur,
} from './styled'

import 'swiper/css'
import 'swiper/css/pagination'

type SmallStoriesProps = {
  stories: StoryType[]
  onSlideClick: (storyId: UniqueId) => void
  isLoading: boolean
}

const loadingBlock = [1, 2, 3, 4, 5]

export function SmallStories({
  stories,
  onSlideClick,
  isLoading,
}: SmallStoriesProps) {
  return (
    <Wrapper>
      <Swiper slidesPerView='auto' spaceBetween={8} grabCursor={true}>
        {isLoading &&
          loadingBlock.map((item) => (
            <SwiperSlide key={item} $isBorder={false} style={{ padding: 0 }}>
              <Skeleton animated $height={120} />
            </SwiperSlide>
          ))}

        {!isLoading &&
          Boolean(stories?.length) &&
          stories.map((story) => (
            <SwiperSlide
              $isBorder={true}
              key={story.id}
              onClick={() => onSlideClick(story.id)}
              data-testid={`story-preview-${story.id}`}
            >
              <StoryContent>
                {(story.title || story.content) && (
                  <StoryContentBlur>
                    {story.title && (
                      <TitleWrapper $lineClamp={2}>{story.title}</TitleWrapper>
                    )}
                    {story.content && (
                      <DescriptionWrapper $lineClamp={2}>
                        {story.content}
                      </DescriptionWrapper>
                    )}
                  </StoryContentBlur>
                )}
              </StoryContent>

              <ImageWrapper>
                <Img url={story.img} />
              </ImageWrapper>
            </SwiperSlide>
          ))}
      </Swiper>
    </Wrapper>
  )
}
